function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.71659 0.0493531C9.88983 0.132613 10 0.307802 10 0.500005V14.5C10 14.6922 9.88983 14.8674 9.71659 14.9507C9.54336 15.0339 9.33774 15.0105 9.18765 14.8904L4.32461 11H0.5C0.223858 11 0 10.7761 0 10.5V4.5C0 4.22386 0.223858 4 0.5 4H4.32461L9.18765 0.10957C9.33774 -0.0104977 9.54336 -0.0339069 9.71659 0.0493531ZM9 1.54032L4.81235 4.89044C4.72369 4.96136 4.61354 5 4.5 5H1V10H4.5C4.61354 10 4.72369 10.0386 4.81235 10.1096L9 13.4597V1.54032Z",
  fill: "#BABABA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8536 5.78355C18.0488 5.58828 18.0488 5.2717 17.8536 5.07644C17.6583 4.88118 17.3417 4.88118 17.1464 5.07644L15.5 6.72289L13.8536 5.07644C13.6583 4.88118 13.3417 4.88118 13.1464 5.07644C12.9512 5.2717 12.9512 5.58828 13.1464 5.78355L14.7929 7.42999L13.1464 9.07644C12.9512 9.2717 12.9512 9.58828 13.1464 9.78355C13.3417 9.97881 13.6583 9.97881 13.8536 9.78355L15.5 8.1371L17.1464 9.78355C17.3417 9.97881 17.6583 9.97881 17.8536 9.78355C18.0488 9.58828 18.0488 9.2717 17.8536 9.07644L16.2071 7.42999L17.8536 5.78355Z",
  fill: "#BABABA"
});

var SvgIconVolumeMute = function SvgIconVolumeMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVolumeMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_volume_mute.ed110558.svg";
export { ForwardRef as ReactComponent };